const WHATSAPP_URL = "https://wa.me/919739737528";
const CALL_URL = "tel:+919739737528";

export default function FloatingContact() {
  return (
    <div className="floating-contact" aria-label="Quick contact">
      <a
        href={WHATSAPP_URL}
        className="floating-contact__btn floating-contact__btn--whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <i className="bx bxl-whatsapp" aria-hidden="true"></i>
        <span>WhatsApp</span>
      </a>
      <a
        href={CALL_URL}
        className="floating-contact__btn floating-contact__btn--call"
        aria-label="Call Us"
      >
        <i className="bx bx-phone" aria-hidden="true"></i>
        <span>Call Us</span>
      </a>
    </div>
  );
}
